import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { siteConfig } from '@/config/site';
import { useLanguage } from '@/context/LanguageContext';

export function FAQSection() {
  const { language } = useLanguage();
  const content = siteConfig.content[language].faq;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0A12]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-[#27D7FF] text-sm font-semibold uppercase tracking-widest mb-2">
            {content.subtitle}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#F4F2FF]">
            {content.title}
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4" data-testid="faq-list">
          {content.items.map((item, idx) => (
            <div
              key={idx}
              className="neon-card overflow-hidden"
              data-testid={`faq-item-${idx}`}
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between text-left"
                data-testid={`faq-toggle-${idx}`}
              >
                <span className="text-[#F4F2FF] font-medium pr-4">{item.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-[#8B5CFF] flex-shrink-0 transition-transform ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 mt-4' : 'max-h-0'
                }`}
              >
                <p className="text-[#A7A3BA] text-sm leading-relaxed border-t border-white/10 pt-4">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
